SupportHelpWizardController = require('../helpWizardController')
Backbone = require 'backbone'
Backbone.$ = $

class SupportCategorizationView extends Backbone.View
  events:
    'click #web-v2-my-order': 'onMyOrderSelection'
    'click #web-v2-my-account':'onMyAccountSelection'
    'click #web-v2-something-else': 'onSomethingElseSelection'
    'click #web-v2-pre-purchase': 'onPrePuchaseSelection'

  render: ->
    switch window.landingStep
      when 'step_1'
        $('#web-v2-my-order').addClass('active')
      when 'step_2'
        $('#web-v2-my-account').addClass('active')
    window.hideFloatingBoldChat()

  getCurrentActiveButton: () ->
    currentActiveButton = $('.active', @$el)

  redirectingToOrder: () =>
    SupportHelpWizardController.initOrdersFetch()

  onMyOrderSelection: () ->
    targetButtonId = 'web-v2-my-order'
    currentActiveButton = @getCurrentActiveButton()
    unless currentActiveButton?.attr('id') is targetButtonId
      @resetGlobalValues()
      Groupon.Support.ABOUT_AN_ORDER = true
      @activateTargetButton(currentActiveButton, targetButtonId)
      if currentUser
        @redirectingToOrder()
      else
        @redirectToUserSignIn({myOrder: true, id: "my-order-sign-in"})

  onMyAccountSelection: ->
    targetButtonId = 'web-v2-my-account'
    currentActiveButton = @getCurrentActiveButton()
    unless currentActiveButton?.attr('id') is targetButtonId
      @resetGlobalValues()
      Groupon.Support.ACCOUNT_RELATED = true
      @activateTargetButton(currentActiveButton, targetButtonId)
      if currentUser
        @redirectSelectIssue()
      else
        @redirectToUserSignIn({myAccount: true, id: "my-account-sign-in"})

  onSomethingElseSelection: ->
    targetButtonId = 'web-v2-something-else'
    currentActiveButton = @getCurrentActiveButton()
    unless currentActiveButton?.attr('id') is targetButtonId
      @resetGlobalValues()
      Groupon.Support.SOMETHING_ELSE = true
      @activateTargetButton(currentActiveButton, targetButtonId)
      @redirectSelectIssue()

  onPrePuchaseSelection: ->
    targetButtonId = 'web-v2-pre-purchase'
    currentActiveButton = @getCurrentActiveButton()
    unless @targetButtonIsActive(currentActiveButton,targetButtonId) is true
      @resetGlobalValues()
      Groupon.Support.PRE_PURCHASE = true
      @activateTargetButton(currentActiveButton, targetButtonId)
      @redirectSelectIssue()

  targetButtonIsActive: (currentActiveButton,targetButtonId)->
    currentActiveButton?.attr('id') is targetButtonId

  resetGlobalValues: ->
    Groupon.Support.SOMETHING_ELSE = false
    Groupon.Support.ACCOUNT_RELATED = false
    Groupon.Support.ABOUT_AN_ORDER = false
    Groupon.Support.PRE_PURCHASE = false

  activateTargetButton: (currentActiveButton, targetButtonId) ->
    currentActiveButton.removeClass('active')
    $("##{targetButtonId}", @$el).addClass('active')

  deActivateCurrentActiveButton: ->
    @getCurrentActiveButton()?.removeClass('active')

  redirectToUserSignIn: (options)->
    SupportHelpWizardController.renderUserSignIn(options)

  redirectSelectIssue: (targetButtonId)->
    Groupon.Support.ContentModel.init(null)
    SupportHelpWizardController.abruptStepTwoFlow()

module.exports = SupportCategorizationView
